<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div>
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link v-bind:to="'/usuario/info_basica/' + id_usuario" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
              <br />
            </div>
          </div>
          <div class="col-lg-12">
            <h3 class="text-orange">Beneficiarios</h3>
            <hr />
            <div class="card">
              <div class="card-body">
                <div v-for="(beneficiario, index_beneficiario) in beneficiarios" v-bind:key="index_beneficiario"
                  class="card card-body shadow border">
                  <div class="row">
                    <div class="col-lg-2">
                      <label>Cedula</label>
                      <input v-model="beneficiario.identificacion" v-on:blur="update_beneficiario(index_beneficiario)"
                        type="text" class="form-control" />
                    </div>
                    <div class="col-lg-2">
                      <label>Nombres</label>
                      <input v-model="beneficiario.nombres" v-on:blur="update_beneficiario(index_beneficiario)"
                        type="text" class="form-control" />
                    </div>
                    <div class="col-lg-2">
                      <label>Apellidos</label>
                      <input v-model="beneficiario.apellidos" v-on:blur="update_beneficiario(index_beneficiario)"
                        type="text" class="form-control" />
                    </div>
                    <div class="col-lg-2">
                      <label>WhatsApp</label>
                      <input v-model="beneficiario.whatsapp" v-on:blur="update_beneficiario(index_beneficiario)"
                        @keypress="isNumber($event)" type="text" class="form-control" />
                    </div>
                    <div class="col-lg-2">
                      <label>Correo electrónico</label>
                      <input v-model="beneficiario.email" v-on:blur="update_beneficiario(index_beneficiario)" type="text"
                        class="form-control" />
                    </div>
                    <div class="col-lg-2">
                      <label>Opciones</label>
                      <button class="form-control btn btn-orange rounded-pill router-link-active"
                        v-on:click="enviar_correo(beneficiario.id_usuario)">Enviar Correo</button>
                    </div>
                  </div>
                  <div class="text-end">
                    <a v-on:click="quitar_beneficiario(index_beneficiario)" href="javascript:void(0)" class="text-danger">
                      <i class="bx bx-trash"></i> Quitar beneficiario
                    </a>
                  </div>
                </div>
                <div class="mt-3">
                  <a v-if="beneficiarios == null || (beneficiarios.length < 2)" v-on:click="agregar_beneficiario"
                    href="javascript:void(0)" class="text-orange">
                    <i class="bx bx-plus-circle"></i> Agregar beneficiario
                  </a>
                </div>
              </div>
            </div>
            <div class="text-end">
              <router-link to="/" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Finalizar
              </router-link>
              <router-link v-bind:to="'/pago/' + id_usuario" class="btn btn-success rounded-pill ms-1">
                Continuar <i class="bx bx-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Beneficiarios",
  metaInfo: {
    title: "Beneficiarios - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      id_usuario: null,
      usuario: [],
      beneficiarios: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          this.get_beneficiarios();
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_beneficiarios: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url +
          "membresias/beneficiarios/" +
          this.usuario.membresia.id_membresia,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.beneficiarios = response.data.data.beneficiarios;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    agregar_beneficiario: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_membresia: this.usuario.membresia.id_membresia,
      };
      axios
        .post(this.$base_url + "membresias/set_beneficiario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }
          vm.get_beneficiarios();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    update_beneficiario: function (index_beneficiario) {
      if (this.beneficiarios[index_beneficiario].email != null) {
        var re = /\S+@\S+\.\S+/;
        var valida_email = re.test(
          this.beneficiarios[index_beneficiario].email
        );

        if (!valida_email) {
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: "Digita una dirección de correo electrónico válida.",
          });
          return false;
        }
      }

      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        beneficiario: this.beneficiarios[index_beneficiario],
      };
      axios
        .post(this.$base_url + "membresias/update_beneficiario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    quitar_beneficiario: function (index_beneficiario) {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_membresia: this.usuario.membresia.id_membresia,
        id_usuario: this.beneficiarios[index_beneficiario].id_usuario,
      };
      axios
        .post(this.$base_url + "membresias/delete_beneficiario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });

            return false;
          }
          vm.get_beneficiarios();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    enviar_correo: function ($id_usuario) {
      console.log("enviando...", $id_usuario)
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        id_usuario: $id_usuario,
      };
      axios
        .post(this.$base_url + "membresias/mail_for_beneficiario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            vm.loading = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "<i class='fa fa-check-circle'></i> ¡Excelente!",
              text: "Se ha enviado correctamente el correo.",
            });
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
  mounted: function () { },
};
</script>